export const components = {
  path: "components",
  reset: () => {},
  getFetchParams: (state) => ({
    type: state.componentFilters.type,
    status: state.componentFilters.status,
    inventory_id: state.componentFilters.inventoryId || 0,
  }),
};
